import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

import { ExportsFormFieldInner } from './ExportsFormFieldInner';

import { fieldTypes } from '../constants';
import { FieldCallMethodResult, FieldType } from '../propTypes';
import { useExportFieldOptionsQuery } from '../../../queries/exportQueries';

const MIN_SEARCHABLE_COUNT = 5;

export const ExportsFormField = ({
  form,

  fieldName,
  fieldLabel,
  fieldType,

  multiple,
  optionsUrl,
  optionsItemMapping,

  disabled,

  formItemLayout,
  onChange,
}) => {
  const { getFieldDecorator } = form;

  const optionsQuery = useExportFieldOptionsQuery({ optionsUrl });

  const isOptionsSearchable = useMemo(() => {
    return optionsQuery?.data?.length >= MIN_SEARCHABLE_COUNT;
  }, [optionsQuery.data.length]);

  return (
    <Form.Item
      label={fieldLabel}
      {...formItemLayout}
    >
      {getFieldDecorator(fieldName, {
        // rules: [{ required: true, message: 'Обязательное поле' }],
        valuePropName: fieldType === fieldTypes.bool ? 'checked' : 'value',
      })(
        <ExportsFormFieldInner
          form={form}
          fieldType={fieldType}
          disabled={disabled}
          multiple={multiple}
          options={optionsQuery?.data || []}
          optionsLoading={optionsQuery?.isFetching}
          optionsSearchable={isOptionsSearchable}
          optionsItemMapping={optionsItemMapping}
          onChange={onChange}
        />
      )}
    </Form.Item>
  );
};

ExportsFormField.propTypes = {
  form: PropTypes.object.isRequired,

  fieldName: PropTypes.string.isRequired,
  fieldLabel: PropTypes.string.isRequired,
  fieldType: FieldType.isRequired,

  multiple: PropTypes.bool,
  optionsUrl: PropTypes.string,
  optionsItemMapping: FieldCallMethodResult,

  disabled: PropTypes.bool,

  formItemLayout: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

ExportsFormField.defaultProps = {
  multiple: false,
  optionsUrl: '',

  disabled: false,
};
